module.exports = __webpack_public_path__ + "static/media/FontAwesome5_Brands.13685372.ttf";